/** Where the game is running: web, a Capacitor shell, or a Discord Activity. */

export type PlatformKind = 'web' | 'capacitor-ios' | 'capacitor-android' | 'discord';

export interface Platform {
  kind: PlatformKind;
  native: boolean;
  /** Discord Activity launch params (the Embedded App SDK needs them) */
  discord: { frameId: string; instanceId: string; platform: string | null } | null;
}

export interface CapacitorGlobal {
  isNativePlatform(): boolean;
  getPlatform(): string;
}

export interface DetectEnv {
  search?: string;
  capacitor?: CapacitorGlobal | null;
}

export function capacitorGlobal(): CapacitorGlobal | null {
  return (globalThis as { Capacitor?: CapacitorGlobal }).Capacitor ?? null;
}

export function detectPlatform(env: DetectEnv = {}): Platform {
  const search = env.search ?? (typeof location === 'undefined' ? '' : location.search);
  const q = new URLSearchParams(search);
  const frameId = q.get('frame_id');
  const instanceId = q.get('instance_id');
  if (frameId && instanceId) return { kind: 'discord', native: false, discord: { frameId, instanceId, platform: q.get('platform') } };
  const cap = env.capacitor === undefined ? capacitorGlobal() : env.capacitor;
  if (cap?.isNativePlatform()) {
    const p = cap.getPlatform();
    if (p === 'ios') return { kind: 'capacitor-ios', native: true, discord: null };
    if (p === 'android') return { kind: 'capacitor-android', native: true, discord: null };
  }
  return { kind: 'web', native: false, discord: null };
}

/** GuestAuthRequest.platform */
export function apiPlatform(p: Platform): 'web' | 'ios' | 'android' | 'discord' {
  return p.kind === 'capacitor-ios' ? 'ios' : p.kind === 'capacitor-android' ? 'android' : p.kind;
}
